// extracted by mini-css-extract-plugin
export default {"userProfilePic":"FeedPage_userProfilePic__MjRUG"};